import { Outlet } from 'react-router-dom';
import AdminSidebar from '@components/dashboard/AdminSidebar';

const AdminLayout = () => {
  return (
    <div className="h-screen bg-white font-sans">
      <AdminSidebar />
      <main className="ml-56 h-full overflow-y-auto p-6">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
